import { ref } from 'vue'
import type { Conversation } from '@/types/dashboard'

// Ref singleton em nível de módulo — compartilhada entre DashboardView e ConvDrawer
// sem que nenhum dos dois precise fazer fetch próprio para se manter sincronizado.
const _conversations = ref<Conversation[]>([])

export function useConversationStore() {
  return {
    conversations: _conversations,
    setConversations: (list: Conversation[]) => { _conversations.value = list },
  }
}

// Fase 4.2 do plano de otimização de login (docs/planos/PLANO-OTIMIZACAO-LOGIN.md):
// chamado no logout — as conversas listadas dependem do escopo de permissão
// de quem estava logado; sem isso, um agente B logando na mesma aba depois
// de A veria a grade de A até o próximo `loadData()` terminar.
export function resetConversationStore(): void {
  _conversations.value = []
}
